export {
  isdpAdminPagePermission,
  isdpLandscapePermission,
  TIER_GROUPS,
  PRODUCT_ID_PATTERN,
  PREMIUM_GROUP_PREFIX,
  isProductIdShape,
  premiumGroup,
  productIdsFromGroups,
  toProductIds,
} from './permissions';
export type { ExternalTier, ProductId } from './permissions';
export {
  DEVHUB_ROLES,
  isDevHubRole,
  groupsForRole,
  roleFromGroups,
  entitledProducts,
  isEntitledTo,
  ALL_PRODUCTS_PREVIEW,
  PREVIEW_HEADER,
  canAccessInternalApp,
  canIssueTokens,
  ROLE_LABELS,
  ROLE_DESCRIPTIONS,
  GROUP_ADMINS,
  GROUP_INTERNAL,
  GROUP_EXTERNAL,
  GROUP_REGISTERED,
  GROUP_PUBLIC,
} from './roles';
export type { DevHubRole } from './roles';
export {
  DEVHUB_CATEGORIES,
  ANNOTATION_CATEGORY,
  ANNOTATION_LEGACY_LANDSCAPE_CATEGORY,
  UNCATEGORISED,
  RETIRED_CATEGORIES,
  RETIRED_CATEGORY_MAP,
  isDevHubCategory,
  compareCategories,
  categoryFromAnnotations,
} from './categories';
export type { DevHubCategory } from './categories';
export { featureEnabled, featureEnabledFromInjectedConfig } from './release';
export type { DevHubFeature, FeatureConfig } from './release';
// draeger.com/docs-icon → image URL, shared by the app's cards, the landscape tiles and the
// backend's landscape logo seed (framework-free, so safe for the backend).
export {
  ANNOTATION_DOCS_ICON,
  PLACEHOLDER_DOCS_ICON,
  TECHDOCS_BASE_PATH,
  techdocsIconPath,
  isRepoRelativeDocsIcon,
  resolveDocsIcon,
} from './docsIcon';
export type { DocsIconEntityRef } from './docsIcon';
// NOTE: OdxSelect (a React component) is intentionally NOT re-exported here.
// This index is a common-library entry imported by the BACKEND; pulling a .tsx
// in would crash the backend runtime. Frontends import it from the "./ui" subpath.

/**
 * Formats an ISO-8601 date/time string (or null) for display.
 * Returns '—' for null, empty, or un-parseable values.
 * Uses toLocaleString() so the output respects the user's locale and timezone.
 * Works in both browser and Node.js environments.
 */
export function fmtDate(value: string | null): string {
  if (!value) return '—';
  const d = new Date(value);
  return Number.isNaN(d.getTime()) ? '—' : d.toLocaleString();
}
